var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar_chart_container" }, [
    _c("div", { ref: "barChart", staticClass: "bar_chart" }),
    _c("div", { staticClass: "bg_card" }, [
      _c("span", [
        _c("span", { staticClass: "bg_blue color_card" }),
        _vm._v(" " + _vm._s(_vm.$t("collectionCenter.inboundTickets"))),
      ]),
      _c("span", [
        _c("span", { staticClass: "bg_green color_card" }),
        _vm._v(" " + _vm._s(_vm.$t("collectionCenter.outboundTickets"))),
      ]),
      _c("span", [
        _c("span", { staticClass: "bg_Pumpkin color_card" }),
        _vm._v(" " + _vm._s(_vm.$t("collectionCenter.inventoryTickets"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }